import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DatiqFileDownloadService {
    constructor() {}

    /**
     *
     * @param blob - File blob to download
     * @param fileName
     */
    triggerDownload(blob: Blob, fileName: string): void {
        const link: HTMLAnchorElement = document.createElement('a');
        const url: string = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    triggerDownloadThroughUrl(url: string, fileName: string): void {
        const link: HTMLAnchorElement = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    base64toBlob(base64String: string, contentType: string): Blob {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
}
